import { isSpecialist, isSpecialistLite, getWhiteList, getPartnersAllowlist } from '../extractFromState';
import { processBusinessDetail } from '../util/dataObjectToStoreObject';
import * as actionTypes from './types';
import { showExpressError } from '../util/errorPopupUtil';
import { fetchBusinessDetailsPage, getBusinessDetailsItem } from '../api/partner';
import { hydrateBusinessesDetailsPage, hydrateBusinessesDetailsList } from './creatorsSync';
import isEqual from 'lodash/isEqual';
import * as SimplrUserAuthorization from '@asurion-core/typescript-utils/SimplrUserAuthorization';

export const businessesDetailsPageLoad = () => async (dispatch, getState) => {
  const state = getState();
  const isAdmin = isSpecialist(state);
  const specialistLite = isSpecialistLite(state);
  const whiteList = getWhiteList(state);
  const partnersAllowlist = getPartnersAllowlist(
    state,
    SimplrUserAuthorization.POLICY_RESOURCES.BUSINESS_DETAIL_MODEL_READ
  );

  let { page, loadLimit, searchParam, businessStatuses, cursor } = state.businesses.pagination;

  const { businessDetails, cursor: nextCursor } = await fetchBusinessDetailsPage({
    isAdmin,
    isSpecialistLite: specialistLite,
    whiteList,
    page,
    loadLimit,
    searchParam,
    businessStatuses,
    cursor,
    partnersAllowlist,
  });

  const newBusinessesDetails = businessDetails.map((businessDetail) => processBusinessDetail(businessDetail));
  dispatch(hydrateBusinessesDetailsPage({ businessDetails: newBusinessesDetails, cursor: nextCursor }));
};

export const loadBusinessDetailsItem = (simplrAccountId) => async (dispatch, getState) => {
  const state = getState();

  if (simplrAccountId && !state.businesses.all[simplrAccountId]) {
    try {
      const businessDetail = await getBusinessDetailsItem(simplrAccountId);
      if (businessDetail) {
        dispatch(hydrateBusinessesDetailsList([businessDetail]));
      }
    } catch (error) {
      showExpressError(error, `Error loading business details for ${simplrAccountId}`);
    }
  }
};

export const setBusinessesDetailsSearchParamsAndLoad =
  (searchParam, businessStatuses) => async (dispatch, getState) => {
    const { businesses } = getState();
    if (
      businesses.pagination.searchParam !== searchParam ||
      !isEqual(businesses.pagination.businessStatuses, businessStatuses)
    ) {
      dispatch({
        type: actionTypes.SET_SEARCH_PARAMS_BUSINESSES_DETAILS,
        searchParam,
        businessStatuses,
      });

      await dispatch(businessesDetailsPageLoad());
    }
  };
